import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect, forwardRef, useImperativeHandle, useCallback } from "react";
import { FormGroup, Label, Col, Row, Button } from "reactstrap";
import { IconPlusCircleOutline } from "@sfx/icons";
import Select from "../../../../../Basic/Select";
import EmailInfo from "../common/emailInfo.component";
import useFormChange from '../../hooks/useFormChange';
import useFetchData from '../../../common/hooks/useFetch';
import { getUserAssignedSolutionsApi, inviteUserApi } from "../../../../api";
import { formatInviteUsersData } from '../../format';
import RequestUserTable from './requestUserTable.componrnt';
import Notification from "../../../../../Basic/Notification";
import Tips from './TipsBanner';
import RequestUserFailedTable from './requestFailedTable.component';
var storedUserAssignedSolutions = null;
var tipsInstance = null;
var UserRequest = /*#__PURE__*/forwardRef(function (props, ref) {
  var translate = props.translate,
      prefix = props.prefix,
      onDataChange = props.onDataChange,
      getHttpRequestStatus = props.getHttpRequestStatus;

  var _useFormChange = useFormChange({}),
      _useFormChange2 = _slicedToArray(_useFormChange, 4),
      formData = _useFormChange2[0],
      setFormItem = _useFormChange2[2],
      resetForm = _useFormChange2[3];

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      tableList = _useState2[0],
      setTableList = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showForm = _useState4[0],
      setShowForm = _useState4[1];

  var _formData$userName = formData.userName,
      userName = _formData$userName === void 0 ? '' : _formData$userName,
      _formData$FirstName = formData.FirstName,
      FirstName = _formData$FirstName === void 0 ? '' : _formData$FirstName,
      _formData$LastName = formData.LastName,
      LastName = _formData$LastName === void 0 ? '' : _formData$LastName,
      _formData$selectedSol = formData.selectedSolution,
      selectedSolution = _formData$selectedSol === void 0 ? [] : _formData$selectedSol;

  var _useFetchData = useFetchData(getUserAssignedSolutionsApi, {
    externalCache: storedUserAssignedSolutions && _toConsumableArray(storedUserAssignedSolutions)
  }),
      userAssignedSolutions = _useFetchData.data,
      userAssignedSolutionsLoading = _useFetchData.isLoading;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      emailValid = _useState6[0],
      setEmailValid = _useState6[1];

  var _useState7 = useState('ADD_FORM'),
      _useState8 = _slicedToArray(_useState7, 2),
      formType = _useState8[0],
      setFormType = _useState8[1];

  var enableDown = userName.trim() && FirstName.trim() && LastName.trim() && emailValid && selectedSolution.length;
  useEffect(function () {
    if (tipsInstance && tipsInstance.remove) {
      tipsInstance.remove();
      tipsInstance = null;
    }
  }, []);
  useEffect(function () {
    resetForm();
    setShowForm(tableList && tableList.length ? false : true);
  }, [resetForm, tableList]); // Whether enable submit or reset data

  useEffect(function () {
    var enableSubmitData = !showForm && tableList && tableList.length ? true : false;
    var enableReset = enableSubmitData;
    onDataChange && onDataChange(enableSubmitData, enableReset);
  }, [tableList, onDataChange, showForm]);
  var onInputChange = useCallback(function (name, value) {
    setFormItem(name, value);
  }, [setFormItem]);

  var onSelectChange = function onSelectChange(item, name) {
    setFormItem(name, item);
  };

  var onEmailValidChange = useCallback(function (emailValid) {
    setEmailValid(emailValid);
  }, []);
  var duplicateEmailCheck = useCallback(function (email) {
    return tableList.findIndex(function (item) {
      return item.userName === email;
    }) > -1;
  }, [tableList]);

  var editFormUser = function editFormUser(e, item) {
    resetForm(_objectSpread({}, item));
    setShowForm(true);
    setFormType('EDIT_FORM');
  };

  var deleteFormUser = function deleteFormUser(e, item) {
    var currentTablist = _toConsumableArray(tableList);

    currentTablist = currentTablist.filter(function (i) {
      return i._id !== item._id;
    });
    setTableList(currentTablist);
  };

  var addFormUser = function addFormUser() {
    resetForm();
    setShowForm(true);
    setFormType('ADD_FORM');
  };

  var saveFormUser = function saveFormUser() {
    var currentTablist = _toConsumableArray(tableList);

    if (formType === 'ADD_FORM') {
      currentTablist.push(_objectSpread({}, formData));
      currentTablist.forEach(function (i, index) {
        i._id = index;
      });
    } else {
      currentTablist = currentTablist.map(function (n) {
        return n._id === formData._id ? _objectSpread({}, formData) : n;
      });
    }

    setTableList(currentTablist);
  };

  var backForm = function backForm() {
    resetForm();
    setShowForm(false);
  };

  useImperativeHandle(ref, function () {
    return {
      reset: function reset() {
        resetForm();
        setFormType('ADD_FORM');
        setTableList([]);
      },
      submit: function () {
        var _submit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var postData, _yield$inviteUserApi, data, item1, item2, _error$response, message;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  getHttpRequestStatus(true, false, false);
                  postData = formatInviteUsersData(tableList);
                  _context.prev = 2;
                  _context.next = 5;
                  return inviteUserApi(postData, {
                    catchError: true
                  });

                case 5:
                  _yield$inviteUserApi = _context.sent;
                  data = _yield$inviteUserApi.data;
                  item1 = data.item1, item2 = data.item2;
                  getHttpRequestStatus(false, true, true);

                  if (item1 && item1.length) {
                    Notification.open({
                      description: translate('SFxAccountSettingsModalRequestUserSubmitRequest', String(item1.length)),
                      type: 'success'
                    });
                  }

                  if (item2 && item2.length) {
                    tipsInstance = Tips.show({
                      getContainer: function getContainer() {
                        return document.getElementById('Tips');
                      },
                      description: /*#__PURE__*/React.createElement(React.Fragment, null, translate('SFxAccountSettingsModalRequestUserSubmitRequestFailed', String(item2.length))),
                      prefix: prefix,
                      translate: translate,
                      modalContent: /*#__PURE__*/React.createElement(RequestUserFailedTable, {
                        data: item2,
                        prefix: prefix,
                        translate: translate
                      })
                    });
                  }

                  _context.next = 18;
                  break;

                case 13:
                  _context.prev = 13;
                  _context.t0 = _context["catch"](2);
                  message = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.data;
                  getHttpRequestStatus(false, true, false);
                  if (message) Notification.open({
                    description: message,
                    type: 'error'
                  });

                case 18:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 13]]);
        }));

        function submit() {
          return _submit.apply(this, arguments);
        }

        return submit;
      }()
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-user-modal"),
    id: "UserTab"
  }, !!tableList.length && /*#__PURE__*/React.createElement(RequestUserTable, {
    data: tableList,
    formData: formData,
    prefix: prefix,
    translate: translate,
    editFormUser: editFormUser,
    deleteFormUser: deleteFormUser
  }), showForm ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EmailInfo, {
    userName: userName,
    FirstName: FirstName,
    LastName: LastName,
    duplicateEmailCheck: duplicateEmailCheck,
    onInputChange: onInputChange,
    translate: translate,
    prefix: prefix,
    onEmailValidChange: onEmailValidChange
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "4"
  }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    for: "selectedSolution"
  }, translate('SFxAccountSettingsUserSolutionLabel')), /*#__PURE__*/React.createElement(Select, {
    isMulti: true,
    renderOption: function renderOption(i) {
      return {
        label: i.displayName || i.name,
        value: i.id
      };
    },
    value: formData.selectedSolution || [],
    options: userAssignedSolutions,
    onChange: function onChange(item) {
      return onSelectChange(item, "selectedSolution");
    },
    isLoading: userAssignedSolutionsLoading
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    className: "".concat(prefix, "-icon-wrap icon-extend text-right")
  }, !!tableList.length && /*#__PURE__*/React.createElement(Button, {
    className: 'button-extend',
    size: "sm",
    onClick: backForm
  }, translate('SFxAccountSettingsBackButtonText')), "\xA0\xA0\xA0\xA0", /*#__PURE__*/React.createElement(Button, {
    className: 'button-extend',
    disabled: !enableDown,
    color: "primary",
    size: "sm",
    onClick: saveFormUser
  }, translate('SFxAccountSettingsDoneButtonText'))))) : /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-icon-wrap icon-extend")
  }, /*#__PURE__*/React.createElement("span", {
    onClick: addFormUser
  }, /*#__PURE__*/React.createElement(IconPlusCircleOutline, {
    size: "18"
  }), "\xA0 ", translate('SFxAccountSettingsAddUserModalAddUser'))));
});
export default UserRequest;